import { DeviceFamily, DeviceType } from "shared/models";

export const isGiottoOrRaffaelloDevice = (deviceType: DeviceType | '' | undefined) => {
    return deviceType
        ? deviceType.deviceFamily === DeviceFamily.Giotto || deviceType.deviceFamily === DeviceFamily.Raffaello
        : false;
};